import { render, staticRenderFns } from "./StandardUserMessage.vue?vue&type=template&id=eecbf8be"
import script from "./StandardUserMessage.vue?vue&type=script&lang=js"
export * from "./StandardUserMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports